import { Modal } from "react-bootstrap";
import "../../../css/ConfirmationModal.css";

const OfferAcceptedModal = ({ show, onContinue, onCancel }) => {
  return (
    <Modal
      show={show}
      centered
      backdrop="static"
      keyboard={false}
      className="related-modal"
    >
      <Modal.Header>
        <Modal.Title className="fs14">Offer Accepted</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="mb-0 confirmtext">
          Your offer has been accepted successfully.
          <br />
          Click <strong>OK</strong> to continue to the Employee Onboarding
          process.
        </p>
      </Modal.Body>

      <Modal.Footer>
           <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-bob-orange"
          onClick={onContinue}
        >
          OK
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default OfferAcceptedModal;